import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { envLoader } from './environments/environment-loader';

import './vendor.ts';
envLoader.then(env => {
  if (env.production) {
    enableProdMode();
  }

  environment.endpoints = env.endpoints;
  environment.authentication = env.authentication;
  environment.ui = env.ui;

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((ctx) => {

      //   setTimeout(() => loadingElement.remove(), 1000);

    })
    .catch(err => console.error(err));

});




